// extracted by mini-css-extract-plugin
module.exports = {"grid":"PeopleFilterSection_grid__1SvtD","fullWidth":"PeopleFilterSection_fullWidth__1LUKy"};